import {
  Conversation,
  ConversationsData,
  Id,
  ConversationsResponse as Response,
  convertConversation,
} from '@nextforce/api'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { getRecentMessagesFromCache } from 'chat/messages/queries/shared/utils'
import keys from 'chat/shared/queries/keys'
import { useUser } from 'users/queries/detail'

export function useConversation(id: Id) {
  const { server } = useServer()
  const client = useQueryClient()
  const { data: user } = useUser()

  const cachedConversations = client.getQueryData<ConversationsData>(
    keys.conversations()
  )
  const cachedConversation = cachedConversations?.find(c => c.id === id)
  const conversationUpdatedAt = client.getQueryState(
    keys.conversations()
  )?.dataUpdatedAt

  const query = useQuery<Conversation>({
    queryKey: keys.conversation(id),
    queryFn: fetchConversationWithStatus,
    enabled: !!user?.id,
    initialData: cachedConversation,
    initialDataUpdatedAt: conversationUpdatedAt,
  })

  return query

  async function fetchConversationWithStatus(): Promise<Conversation> {
    const conversation = await fetchConversation()
    const recentMessageMap = getRecentMessagesFromCache(client)

    return {
      ...conversation,
      status: {
        lastViewedTimestamp: conversation.status?.lastViewedTimestamp,
        recentMessage: recentMessageMap?.[conversation.id],
      },
    }
  }

  async function fetchConversation() {
    const response = await server.get<Response.Conversation>(
      `/v2/chat/conversations/${id}`
    )

    return convertConversation(response)
  }
}
